import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";
import "@rageeb/frontend-lib/styles/main.css";
import "@moznsystems/mozn-ui/dist/mozn-ui.css";
import "./layout-overrides.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<BrowserRouter>
		<App />
	</BrowserRouter>,
);
